import React from 'react';
import { SectionHeading } from '../SectionHeading';
import { audienceParagraphs } from '../../data/salesContent';
export function AudienceSection() {
  return <section className="bg-canvas px-5 py-20 md:py-28" data-id="element-69" data-mp="3re4qkb0zcbcm">
      <div className="mx-auto grid max-w-6xl gap-10 lg:grid-cols-[1fr_1.4fr] lg:gap-16" data-id="element-70" data-mp="95cnejuppjel">
        <SectionHeading title="¿Para quién es?" align="left" data-id="element-71" data-mp="472r25x94cre" />
        <div className="space-y-6" data-id="element-72" data-mp="45hrg1w2y3mo">
          {audienceParagraphs.map((p, i) => <p key={p} className={i === 0 ? 'text-xl font-medium leading-relaxed text-ink md:text-2xl' : 'text-lg leading-relaxed text-muted md:text-xl'} data-id="element-73" data-mp="3cndzx6b4jib3" data-mpi={i}>
              {p}
            </p>)}
        </div>
      </div>
    </section>;
}